const CommonModal = ({
  show,
  title,
  children,
  footer,
  onClose,
  width = "500px",
}) => {
  if (!show) return null;

  return (
    <>
      <div className="common-modal-overlay">
        <div className="common-modal" style={{ maxWidth: width }}>
          <div className="common-modal-header">
            <h5>{title}</h5>
            <button className="close-btn" onClick={onClose}>
              ✕
            </button>
          </div>

          <div className="common-modal-body">{children}</div>

          {footer && <div className="common-modal-footer">{footer}</div>}
        </div>
      </div>
    </>
  );
};

export default CommonModal;


